export default "__VITE_PUBLIC_ASSET__cdde4255__"